
import { api } from '@/lib/api';
import { useQuery, useMutation } from '@tanstack/react-query';

export const useReports = () => ({
  seSummary: () => useQuery({
    queryKey: ['se_summary'],
    queryFn: () => api.get('/se/dashboard/summary').then(r => r.data)
  }),
  
  seOrders: (params: any) => useQuery({
    queryKey: ['se_orders', params],
    queryFn: () => api.get('/se/reports/orders-booked', { params }).then(r => r.data)
  }),
  
  gst1: (params: any) => useQuery({
    queryKey: ['gst1', params],
    queryFn: () => api.get('/admin/gst/gstr1', { params }).then(r => r.data)
  }),
  
  gst3b: (params: any) => useQuery({
    queryKey: ['gst3b', params],
    queryFn: () => api.get('/admin/gst/gstr3b', { params }).then(r => r.data)
  }),
  
  supplier: (params: any) => useQuery({
    queryKey: ['sup_perf', params],
    queryFn: () => api.get('/ho-manager/suppliers/performance', { params }).then(r => r.data)
  }),
  
  branch: (params: any) => useQuery({
    queryKey: ['branch_analytics', params],
    queryFn: () => api.get('/head-ops/branches/analytics', { params }).then(r => r.data)
  }),

  // Module 06 - Extended Reports & Compliance
  audit: (params: any) => useQuery({
    queryKey: ['audit', params],
    queryFn: () => api.get('/admin/reports/audit', { params }).then(r => r.data)
  }),
  
  compliance: (params: any) => useQuery({
    queryKey: ['compliance', params],
    queryFn: () => api.get('/admin/reports/compliance', { params }).then(r => r.data)
  }),
  
  finance: (params: any) => useQuery({
    queryKey: ['finance', params],
    queryFn: () => api.get('/finance/reports/monthly', { params }).then(r => r.data)
  }),
  
  scheduled: () => useMutation({
    mutationFn: (data: any) => api.post('/ops/reports/scheduled', data)
  })
});
